module.exports = __webpack_public_path__ + "static/media/logoPDF.555db178.png";